import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { Icon, BorderlessInput, SecondaryTextSm } from 'atoms';
import {
  FilterHeaderWrapper, RelativeWrapper, RowCenterScrollWrapper,
  FlexCenterJustifyCenterWrapper, FlexBoxWrapper, FlexGrowCenterOverflowHiddenWrapper,
  UnitDropdownBodyWrapper, FullWidthHeightJustifyCenter, Mt3, Mb3
} from 'wrappers';
import internalState from './internalState';
import { HomeSvg, PlusSignSvg, LoadingIndicatorSvg } from 'components/icons';
import { UnitRow } from './molecules';
import { DropdownTextButton, TextButton, IconTextButton } from 'molecules';

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: 'ResidentSelector',
  controller: Controller,
  initialProps: ({ selectedPropertyId, residentList, openOnTop, hideAddUnitButton, isAddUnitButtonExternalFunction }) => ({ selectedPropertyId, residentList, openOnTop, hideAddUnitButton, isAddUnitButtonExternalFunction, searchTerm: '', units: [] }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'HeaderWrapper',
      ref: headerRef,
      isButton: true,
      bindings: ({ isOpen }) => ({ isOpen, containerRef }),
      elements: [
        {
          wrapper: FlexGrowCenterOverflowHiddenWrapper,
          name: 'LeftSideWrapper',
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => HomeSvg({ selected: true })
            },
            {
              wrapper: RowCenterScrollWrapper,
              name: 'Wrapper',
              elements: [
                {
                  component: DropdownTextButton,
                  name: 'SelectedButton',
                  isListOf: { resident: ({ residentList }) => residentList },
                  bindings: ({ resident, residentList }) => ({ text: `${resident.number} ${resident.tenant_name ? ` - ${resident.tenant_name}` : ''}`, residentList, resident })
                },
                {
                  component: BorderlessInput,
                  name: 'SearchInput',
                  bindings: ({ searchTerm, selectedPropertyId }) => ({ selectedPropertyId, value: searchTerm, placeholder: "Units" })
                }
              ]
            }
          ]
        },
        {
          component: IconTextButton,
          name: 'AddUnit',
          renderIf: ({ residentList, hideAddUnitButton }) => residentList?.length > 0 && !hideAddUnitButton,
          bindings: ({ isOpen, isAddUnitButtonExternalFunction, residentList }) =>
            ({ title: 'Add Unit', icon: PlusSignSvg({}), isOpen, isAddUnitButtonExternalFunction, residentList })
        },
      ]
    },
    {
      wrapper: UnitDropdownBodyWrapper,
      name: 'Body',
      ref: containerRef,
      renderIf: ({ isOpen, units, loadingResidents, searchTerm }) => isOpen && (units && units.length > 0 || loadingResidents || searchTerm),
      displayState: ({ openOnTop }) => ({ openOnTop }),
      elements: [
        {
          component: wrap(wrap(wrap(Icon, Mt3), Mb3), FullWidthHeightJustifyCenter),
          name: 'LoadingIndicator',
          displayValue: () => LoadingIndicatorSvg({ width: '40px', height: '40px' }),
          renderIf: ({ loadingResidents }) => loadingResidents,
          bindings: () => ({})
        },
        {
          component: wrap(wrap(wrap(SecondaryTextSm, Mt3), Mb3), FullWidthHeightJustifyCenter),
          name: 'ResidentNamePlaceholder',
          renderIf: ({ units, loadingResidents }) => units.length === 0 && !loadingResidents,
          displayValue: () => 'No result for your search',
          bindings: () => ({})
        },
        {
          component: UnitRow,
          name: 'Unit',
          renderIf: ({ loadingResidents }) => !loadingResidents,
          isListOf: { unit: ({ units, pageNumber, residentList }) => units.filter(u => !residentList.map(r => r.id).includes(u.id)).slice(0, pageNumber * 10) },
          bindings: ({ unit, residentList }) => ({ residentList, unit }),
        },
        {
          component: wrap(wrap(TextButton, FlexBoxWrapper), FlexCenterJustifyCenterWrapper),
          name: 'LoadMore',
          renderIf: ({ units, pageNumber, loadingResidents }) => (pageNumber * 10) < units.length && !loadingResidents,
          bindings: ({ pageNumber }) => ({ title: 'Load More...', pageNumber })
        }
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), RelativeWrapper)
